import { render, staticRenderFns } from "./icon-rss-folder.vue?vue&type=template&id=28c68afe&"
import script from "./icon-rss-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-rss-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports